import React from 'react';
import "./css/Sidebar.css";
import Avatar from '@material-ui/core/Avatar';
import SocialHandles from "./SocialHandles";

function Sidebar() {
    return (
        <div className="sidebar">
            <div className="sidebar__glass"></div>
            
            <div className="sidebar__content">
                    <Avatar src={"https://avatars.githubusercontent.com/u/32255144?v=4"} className="sidebar__content__avatar" />
                    <h3>Aman Bansal</h3>
                    <p>C++ Developer</p>
                    <SocialHandles />
                    {/* <BlogPost /> */}
            </div>
        </div>
    )
}

export default Sidebar
